import React from 'react';
import './App.css';

function WhatTime(){
  const date = new Date()
  const hours = date.getHours()
  let timeOfDay
  const styles = {
    fontSize: 26
  }
    if (hours < 12){
          timeOfDay = "Good Morning!"
          styles.color = "green"
        } else if (hours > 12 && hours < 17){
          timeOfDay = "Good Afternoon!"
          styles.color = "red"
        } else if (hours > 17 && hours < 20){
          timeOfDay = "Good Evening!"
          styles.color = "blue"
        }  else {
          timeOfDay = "Good Night!"
          styles.color = "orange"
        }
  
  return (
      <div className="App" style={styles}>
        {timeOfDay}
      </div>
    );
}



export default WhatTime;
